/**
 * Workflow-manager template key of the Nawy Now loan flow (crm tenant).
 * "loan-unified" is the unified flow that carries primary + joint + guarantor blocks.
 */
// §LOB: the CRM names the product; workflow-manager instantiates its configured DEFAULT flow for it.
export const NAWY_NOW_LINE_OF_BUSINESS = "NAWY_NOW";
